import { render } from "./B2bTableUsuarios.vue?vue&type=template&id=d0703754&scoped=true&lang=pug"
import script from "./B2bTableUsuarios.vue?vue&type=script&lang=js"
export * from "./B2bTableUsuarios.vue?vue&type=script&lang=js"

import "./B2bTableUsuarios.vue?vue&type=style&index=0&id=d0703754&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0703754"]])

export default __exports__